export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8509.83d57736.jpg";